import React from "react"
import { Link } from "react-router-dom"
import Back from "../common/back/Back"
import "./features.css"

const offerings = [
  { icon: "fa fa-broadcast-tower", title: "Live Trading Sessions",         desc: "Watch Mr. Ali execute real trades in real-time, explaining every decision — entry, exit, risk sizing, and why." },
  { icon: "fa fa-laptop-code",     title: "Trading Simulations",           desc: "Practice on demo accounts with guided feedback. Build confidence before risking real capital." },
  { icon: "fa fa-calendar-week",   title: "Weekly Market Reviews",         desc: "Every week, break down what happened in the markets and what setups to watch in the coming week." },
  { icon: "fa fa-user-tie",        title: "One-on-One Coaching Sessions",  desc: "Dedicated time with your mentor to review your trades, identify mistakes, and build better habits." },
  { icon: "fa fa-book",            title: "Trading Journals",              desc: "We teach you to track every trade with data — entries, exits, emotions, and outcomes — for continuous improvement." },
  { icon: "fa fa-chart-pie",       title: "Performance Tracking",          desc: "Review your trading performance metrics: win rate, risk-to-reward, drawdown, and consistency." },
]

const classSize = [
  { n: "5–10", label: "Students per class", icon: "fa fa-users" },
  { n: "1:1",  label: "Coaching ratio",     icon: "fa fa-user-tie" },
  { n: "100%", label: "Real market focus",  icon: "fa fa-chart-line" },
]

const Mentorship = () => (
  <>
    <Back title="One-on-One Mentorship" />

    <section className="feature-page padding">
      <div className="container">

        {/* Hero intro */}
        <div className="feature-intro">
          <div className="feature-intro-icon mentor">
            <i className="fa fa-user-tie"></i>
          </div>
          <div className="feature-intro-text">
            <p className="feature-eyebrow">MENTORSHIP</p>
            <h2>Learn Directly From a Professional Trader</h2>
            <p>
              Our small-class setup enables <strong>genuine one-on-one instructor engagement</strong>.
              Real traders guide you through live market conditions — not just slides.
            </p>
            <p>
              Mr. Ali has over a decade of active experience in global financial markets. He
              developed a disciplined, risk-first methodology through years of personal trading
              — and now passes that knowledge directly to every student.
            </p>
            <blockquote className="feature-quote">
              "Most trading courses teach you what to look at. We teach you what to actually
              do — and, more importantly, what <em>not</em> to do."
              <span>— Mr. Ali, Founder</span>
            </blockquote>
          </div>
        </div>

        {/* Class size stats */}
        <div className="feature-section">
          <div className="mentor-stats-row">
            {classSize.map((s, i) => (
              <div className="mentor-stat" key={i}>
                <div className="mentor-stat-icon"><i className={s.icon}></i></div>
                <div className="mentor-stat-num">{s.n}</div>
                <div className="mentor-stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* What mentorship includes */}
        <div className="feature-section">
          <h3 className="feature-section-title"><i className="fa fa-list-check"></i> What Mentorship Includes</h3>
          <div className="mentor-offerings-grid">
            {offerings.map((o, i) => (
              <div className="mentor-offering" key={i}>
                <div className="mentor-offering-icon"><i className={o.icon}></i></div>
                <div>
                  <h4>{o.title}</h4>
                  <p>{o.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mentor profile */}
        <div className="feature-section">
          <div className="mentor-profile-card">
            <div className="mentor-profile-avatar">
              <i className="fa fa-user-tie"></i>
            </div>
            <div className="mentor-profile-info">
              <span className="mentor-profile-tag">FOUNDER & HEAD OF TRADING EDUCATION</span>
              <h3>Mr. Ali</h3>
              <p>10+ years of active trading in Forex, Commodities, and Indices. Specialises in technical and price action analysis, risk management, trading psychology, and rule-based strategy development.</p>
              <div className="mentor-skills">
                {["Technical & Price Action","Risk Management","Trading Psychology","Rule-Based Strategies","Beginner to Expert Mentoring"].map((s, i) => (
                  <span key={i}><i className="fa fa-check-circle"></i>{s}</span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="feature-section feature-cta-section">
          <h3>Get personalised guidance from day one</h3>
          <p>Join a small class and learn directly with Mr. Ali in real market conditions.</p>
          <div className="feature-cta-btns">
            <Link to="/courses" className="feature-btn primary">
              <i className="fa fa-graduation-cap"></i> View Programmes
            </Link>
            <a href="https://wa.me/254723000200" target="_blank" rel="noreferrer" className="feature-btn whatsapp">
              <i className="fab fa-whatsapp"></i> Talk to Mr. Ali
            </a>
          </div>
        </div>

      </div>
    </section>
  </>
)

export default Mentorship
